import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Trash2, Minus, Plus } from "lucide-react";

export default function Cart() {
    const { items, update, remove, subtotal } = useCart();
    const shipping = subtotal >= 50 ? 0 : subtotal === 0 ? 0 : 4.9;
    const total = subtotal + shipping;

    return (
        <>
            <Navbar variant="light" />
            <section className="pt-32 pb-20 bg-beige-natural min-h-[70vh]">
                <div className="container-edge">
                    <span className="label-overline text-wine">Cesto</span>
                    <h1 className="mt-4 font-heading text-5xl md:text-6xl text-wine-dark">O seu carrinho</h1>

                    {items.length === 0 ? (
                        <div className="mt-16 text-center py-20 border border-wine-dark/10 bg-white">
                            <p className="text-wine-dark/70">O seu carrinho está vazio.</p>
                            <Link to="/marketplace" className="btn-wine mt-8 inline-flex" data-testid="empty-cart-cta">
                                Descobrir produtos
                            </Link>
                        </div>
                    ) : (
                        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
                            <div className="lg:col-span-8 space-y-6">
                                {items.map((it) => (
                                    <div key={it.product_id} className="bg-white p-6 flex items-center gap-6 border border-wine-dark/10" data-testid={`cart-row-${it.product_id}`}>
                                        <img src={it.image} alt={it.name} className="w-24 h-24 object-cover" />
                                        <div className="flex-1">
                                            <h3 className="font-heading text-xl text-wine-dark">{it.name}</h3>
                                            <p className="text-sm text-wine-dark/60 mt-1">€{it.price.toFixed(2)}</p>
                                        </div>
                                        <div className="flex items-center border border-wine-dark/30">
                                            <button onClick={() => update(it.product_id, it.quantity - 1)} className="p-2"><Minus className="h-4 w-4" /></button>
                                            <span className="px-4 text-sm">{it.quantity}</span>
                                            <button onClick={() => update(it.product_id, it.quantity + 1)} className="p-2"><Plus className="h-4 w-4" /></button>
                                        </div>
                                        <div className="font-heading text-lg text-wine-dark w-20 text-right">
                                            €{(it.price * it.quantity).toFixed(2)}
                                        </div>
                                        <button onClick={() => remove(it.product_id)} className="text-wine-dark/60 hover:text-destructive" data-testid={`cart-remove-${it.product_id}`}>
                                            <Trash2 className="h-4 w-4" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <aside className="lg:col-span-4">
                                <div className="bg-white p-8 border border-wine-dark/10 sticky top-28">
                                    <h3 className="label-overline text-wine">Resumo</h3>
                                    <div className="mt-6 space-y-3 text-sm">
                                        <Row label="Subtotal" value={`€${subtotal.toFixed(2)}`} />
                                        <Row label="Envio" value={shipping === 0 ? "Grátis" : `€${shipping.toFixed(2)}`} />
                                        {subtotal < 50 && subtotal > 0 && (
                                            <p className="text-xs text-wine-dark/60 italic">
                                                Envio grátis para encomendas acima de €50.
                                            </p>
                                        )}
                                    </div>
                                    <div className="hairline my-6" />
                                    <div className="flex items-center justify-between">
                                        <span className="label-overline text-wine">Total</span>
                                        <span className="font-heading text-3xl text-wine-dark">€{total.toFixed(2)}</span>
                                    </div>
                                    <Link to="/checkout" className="btn-wine w-full mt-8" data-testid="cart-checkout-cta">
                                        Finalizar compra
                                    </Link>
                                </div>
                            </aside>
                        </div>
                    )}
                </div>
            </section>
            <Footer />
        </>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex items-center justify-between text-wine-dark/80">
            <span>{label}</span>
            <span>{value}</span>
        </div>
    );
}
